<template>
  <v-data-table
    :headers="getMainTableHeaders"
    :items="getTicketsList"
    :total-items="totalItems"
    :loading="loading"
    :pagination="paginationData"
    :rows-per-page-items="[5, 10, 25, 50, 100]"
    @update:pagination="onPaginationUpdate"
    sort-icon="fa-arrow-down" class="elevation-1 main-table"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.ticket_number }}</td>
      <td>{{ props.item.invoice_number }}</td>
      <td>{{ props.item.ticket_person }}</td>
      <td>{{ props.item.column_used }}</td>
      <td>{{ props.item.status | convertStatusToName }}</td>
      <td>{{ props.item.locked | convertLockedToName }}</td>
      <td>{{ moment(props.item.created).format('DD-MM-YYYY')}}</td>
      <td>{{ moment(props.item.expiration_date).format('DD-MM-YYYY')}}</td>
      <td>PLN {{ props.item.price }}</td>
      <td class="text-xs-center">
        <div>
          <v-btn small color="#555474"
                 @click="$router.push({name:'TicketDetails', params: {ticketId: props.item.id}})" dark>Zobacz
          </v-btn>
          <v-menu bottom offset-y>
            <v-btn small slot="activator">Więcej
              <v-icon size="15px" class="ml-2 mr-0">fas fa-caret-down</v-icon>
            </v-btn>
            <v-list class="v-list--button-list">
              <v-list-tile v-if="props.item.status !== 'F' && props.item.locked === 0 && moment(props.item.expiration_date).format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')"
                           @click="$router.push({name: 'AddRealizationTicket', params: {ticketId: props.item.id}})">
                <v-list-tile-title>Dodaj realizację</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="props.item.status === 'N'"
                           v-permissions
                           @click="$emit('deleteTicket',props.item.id, 'deleteTicket', false)"
                           class="v-menu--v-list-title-delete">
                <v-list-tile-title>Usuń</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="$router.push({name: 'EditTicket', params: {ticketId: props.item.id}})">
                <v-list-tile-title>Edytuj</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="$emit('printPDF',props.item.id)">
                <v-list-tile-title>Drukuj</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                  @click="$emit('exportPDF', props.item.id, `${props.item.id}_${moment(props.item.created_at).format('YYYY')}`, props.item.type ? props.item.type.name : 'Brak')">
                <v-list-tile-title>Eksportuj PDF</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </td>
    </template>
    <template slot="footer">
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td><strong>Suma</strong></td>
      <td><strong>PLN {{calculateAllValues('price')}}</strong></td>
      <td></td>
    </template>
  </v-data-table>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'TicketTable',
    props: {
      loading: Boolean,
      totalItems: { type: Number, default: 0 },
      currentPage: { type: Number, default: 1 },
    },
    data() {
      return {
        initialized: false,
        paginationData: {
          descending: false,
          page: 1,
          rowsPerPage: 10,
        },
      };
    },
    mounted() {
      this.$nextTick(() => { this.initialized = true; });
    },
    watch: {
      currentPage(val) {
        this.paginationData = Object.assign({}, this.paginationData, { page: val });
      },
    },
    computed: {
      ...mapGetters('AuthStore', ['getUserRole']),
      ...mapGetters('TicketStore', ['getMainTableHeaders', 'getTicketsList', 'getRealizationsHeaders']),
    },
    methods: {
      onPaginationUpdate(pagination) {
        this.paginationData = pagination;
        if (this.initialized) {
          this.$emit('paginationChange', pagination);
        }
      },
      calculateAllValues(key) {
        if (this.getTicketsList.length > 0) {
          const result = this.getTicketsList
              .map(item => Number(item[key]) || 0)
              .reduce((a, b) => a + b);
          return result || 0;
        }
        return 0;
      },
    },
    filters: {
      convertStatusToName(status) {
        switch (status) {
          case 'F':
            return 'Zakończony';
          case 'N':
            return 'Nowe';
          case 'I':
            return 'W realizacji';
          default:
            return 'Nieznany status';
        }
      },
      convertLockedToName(locked) {
        switch (locked) {
          case 0:
            return 'NIE';
          case 1:
            return 'TAK';
          default:
            return 'Nieznany';
        }
      },
    },
  };
</script>

<style scoped>

</style>
